import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useParams } from "react-router-dom";
import Button from "../components/form/Button";
import Image from "../components/elements/Image";
import { classNames } from "../helpers/classNames";
import { useSelector } from "react-redux";
import AuthDropdown from "./AuthDropdown";
import MainLogo from "../../src/assets/image/main-logo.svg";

const FrontHeader = () => {
  const params = useParams();
  const location = useLocation();
  const { session } = useSelector((state) => state?.authProvider);
  const user = useSelector((state) => state?.profile?.data);

  const [menuOpen, setMenuOpen] = useState(false);
  const [isAppStatus, setAppStatus] = useState(false);
  const [language, setLanguage] = useState(1);
  const { siteSetting } = useSelector((state) => state?.setting || {});
  const menudata = [
    { _id: 1, link: "/about", name: "About" },
    { _id: 2, link: "/testimonials", name: "Testimonials" },
    { _id: 3, link: "/careers", name: "Careers" },
    { _id: 4, link: "/blogs", name: "Blogs" },
    { _id: 5, link: "/helps", name: "Helps" },
  ];

  useEffect(() => {
    if (location?.hash === "#status") {
      setAppStatus(true);
    }
  }, [location?.hash]);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <>
      <header className="w-full">
        <div className="w-full">
          <div className="px-5 shadow-[0px_2px_10px_rgba(0,0,0,0.2)] gap-1 md:gap-4">
            <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4">
              <div className="flex justify-between gap-52">
                <div className="h-28 md:h-28 w-40 overflow-hidden mr-auto xls:mr-0 bg-white pt-7 px-5 flex-shrink-0">
                    <Link to={"/"} className="flex w-full h-full">
                      <Image
                        src={MainLogo}
                        alt=""
                        effect={"blur"}
                        classes={"object-contain object-left"}
                      />
                    </Link>
                </div>
                <div className="flex items-center justify-between w-full">
                  <div className="relative z-[1] order-2 xls:order-1 mx-auto">
                    <div className="relative xls:hidden">
                      <Button
                        buttonClasses={
                          "!h-10 md:!h-12 !rounded-lg !px-0 !aspect-square"
                        }
                        buttonHasLink={false}
                        buttonIcon={"fa-regular fa-fw fa-bars text-2xl"}
                        buttonIconPosition={"left"}
                        buttonFunction={() => setMenuOpen(true)}
                      />
                    </div>
                    <div
                      className={classNames(
                        "fixed top-0 left-0 w-full h-full bg-black/75 z-0 xls:hidden transition-all duration-200",
                        menuOpen ? "opacity-100 visible" : "opacity-0 invisible"
                      )}
                      onClick={() => setMenuOpen(false)}
                    ></div>
                    <div
                      className={classNames(
                        "fixed top-0 left-0 w-full h-full max-w-64 z-20 bg-slate-200 xls:bg-transparent shadow-[-4px_0_20px_rgba(0,0,0,0.15)] xls:relative xls:top-auto xls:left-auto xls:w-auto xls:h-auto xls:max-w-none xls:shadow-none transition-all duration-200",
                        menuOpen
                          ? "translate-x-0"
                          : "-translate-x-full xls:translate-x-0"
                      )}
                    >
                      {menudata?.length > 0 && (
                        <nav className="relative flex px-8 py-8 xls:py-0 xls:px-0">
                          <div className="flex flex-col w-full xls:flex-row gap-4 xls:gap-8">
                            {menudata?.map((item, index) => (
                              <NavLink
                                to={item.link}
                                key={index}
                                className={({ isActive }) =>
                                  classNames(
                                    "relative flex items-center text-xl xls:text-base font-bold h-10 xls:h-20 capitalize",
                                    "after:hidden after:xls:block after:content-[''] after:absolute after:bottom-0 after:left-1/2 after:w-12 after:h-1.5 after:bg-primary after:rounded-t-md after:transition-all after:duration-300 after:origin-center after:-translate-x-1/2 after:scale-x-0 ",
                                    isActive
                                      ? "after:scale-x-100 text-primary xls:text-sidebar"
                                      : "after:hover:scale-x-100 text-white"
                                  )
                                }
                              >
                                {item.name}
                              </NavLink>
                            ))}
                          </div>
                        </nav>
                      )}
                    </div>
                  </div>
                  <div className="relative z-0 order-1 xls:order-2 flex items-center gap-3">
                    <Button
                      buttonClasses={"!px-3 md:!px-7"}
                      buttonHasLink={false}
                      buttonLabel={"Buy Crypto"}
                      buttonLabelClasses={
                        "!text-xs md:!text-lg whitespace-nowrap uppercase font-semibold text-white text-stroke-2-primary"
                      }
                    />
                    <Button
                      buttonClasses={"!px-3 md:!px-7 !bg-buttonRed !border-borderButtonRed"}
                      buttonHasLink={false}
                      buttonLabel={"Sell Crypto"}
                      buttonLabelClasses={
                        "!text-xs md:!text-lg whitespace-nowrap uppercase font-semibold text-white text-stroke-2-borderButtonRed"
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default FrontHeader;
